<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-04-19 15:14:15
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2023-05-09 16:05:02
 * @FilePath: \NCCEE2\src\views\Login\login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="Loginlogo">
      <img src="../../assets/images/logo.png" alt />
      <div class="baseName">气候极端事件风险防范决策支持系统</div>
    </div>
    <el-card class="box-card">
      <div class="title">
        <p>系统登录</p>
      </div>
      <el-divider></el-divider>
      <div class="bodyer">
        <el-input
          type="text"
          suffix-icon="el-icon-user-solid"
          placeholder="请输入账号"
          style="width: 300px; margin-top: 20px;"
          v-model="username"
        ></el-input>
        <br />

        <el-input
          type="password"
          suffix-icon="el-icon-key"
          placeholder="请输入密码"
          style="width: 300px; margin-top: 20px;"
          v-model="password"
        ></el-input>
      </div>
      <div class="footer" style=" margin-top: 40px;">
        <el-button type="primary" style="width: 300px; height: 50px;" @click="submit">登录</el-button>
      </div>
      <div class="forget">
        <p style="font-size: 14px;margin-top: 150px;padding-left: 150px; color: #409EFF;">忘记密码？</p>
      </div>
    </el-card>
    <div class="maplogo">
      <img src="../../assets/images/maplogo.png" alt />
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import Cookies from "js-cookie";
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  created() {
    console.log(Cookies.get("isNccLogin"));
    if (Cookies.get("isNccLogin")) {
      this.$store.commit("setLogin", true);
      this.$router.push("/home");
    } else {
      this.$message({
        message: "登录已过期",
        type: "warning"
      });
    }
  },
  methods: {
    submit() {
      let formData = new FormData();
      formData.append("name", md5(this.username));
      formData.append("password", md5(this.password));
      axios({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `http://47.108.55.246:7090/UserService/login`,
        data: formData,
        method: "post"
      }).then(e => {
        // console.log(e.data);
        if (e.data.message == "success") {
          this.$store.commit("setLogin", true);
          this.$router.push("/home");
          Cookies.set("isNccLogin", true, { expires: 2 });
        } else {
          console.log(1212);
          this.$message({
            message: "账号密码异常",
            type: "warning"
          });
        }
      });
    }
  }
};
</script>
<style>
body {
  padding: 0;
  margin: 0;
}
.content {
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url(../../assets/images/banner.png);
}
.Loginlogo {
  position: absolute;
  left: 10%;
  top: 5vh;
  z-index: 2;
  /* display: flex; */
  align-items: center;
  /* height: 80px;
  line-height: 80px; */
}
.Loginlogo img {
  /* width: auto; */
  max-width: 50%;
  width: 200px;
  margin-top: 30px;
}
.maplogo {
  position: absolute;
  left: 45%;
  top: 18vh;
}
.maplogo img {
  width: auto;
  max-width: 100%;
}
.box-card {
  width: 400px;
  height: 500px;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 15%;
  top: 30vh;
  z-index: 3;
}
.box-card p {
  font-weight: 400;
  font-size: 28px;
  margin-left: 35%;
}

.box-card .bodyer .el-input__inner {
  height: 55px !important;
}

.footer {
  display: flex;
  justify-content: center;
}
.baseName {
  width: 100%;
  height: 50px;
  /* background-color: aqua; */

  font-weight: 700;
  color: #103a86;
  font-size: 50px;
  text-align: center;
  -webkit-text-stroke: 1px rgb(255, 255, 255);
}

.el-message {
  z-index: 99999999 !important;
}
</style>